import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

// import { ListElement } from '../common/StyledComponents/ListElement';
import AdBanner from '../common/AdBanner/AdBanner';
import { Image } from '../common/StyledComponents/Image';
import InnerBox from '../common/InnerBox/InnerBox';
import OuterBox from '../common/OuterBox/OuterBox';
import Banner from '../common/Banner/Banner';
import { SideBar } from '../common/StyledComponents/StyledSideBar';
import Latest from '../common/Latest/Latest';

import appLink from '../../assets/images/play-store-logo.png';
import adTissot from '../../assets/images/ad-tissot.png';
// import adSuggested from '../../assets/images/ad-suggested.png';
import phoneWithApp from '../../assets/phone-with-app.png';
// import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';
import adLinkedin from '../../assets/images/ad-linkedin.png';
import adAmazon from '../../assets/images/ad-amazon.png';
// import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';
import adAmazonVertical from '../../assets/images/ad-amazon-vertical.png';
// import List_XS_Image from '../common/ListWithImage/List_XS_Image';
import List_S_Image from '../common/ListWithImage/List_S_Image';
// import List_M_Image from '../common/ListWithImage/List_M_Image';
import { FlexContainer } from '../common/StyledComponents/FlexContainer';
import { Title } from '../common/StyledComponents/Title';
import ReviewsOnHomePage from './ReviewsOnHomePage';
import BannerLoader from '../common/Loaders/BannerLoader';

const goToURL = url => {
  window.open(url, '_blank');
};

class Home extends Component {
  componentWillMount = () => {
    // console.log('[Home.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[News.js] componentDidMount');
    this.props.onFetchHomeBanner();
    this.props.onFetchLatest(1);
    this.props.onFetchTrending();
    this.props.onFetchReviews();
  };

  componentDidUpdate = (prevProps, prevState) => {
    // Make API requests according to the page that needs to be fetched.
  };

  handlePageChange = page => {
    this.props.onFetchLatest(page);
  };

  handleLoadMore = () => {
    this.props.onFetchLatest(this.props.pageForLatest);
  };

  navigateAndIncreasePostCount = (postId, postSlug) => {
    // console.log('postId: ', postId);
    // console.log('postSlug: ', postSlug);
    // this.props.onIncreasePostCount(postId);
    this.navigate(postSlug);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    const { bannerData, latest, reviews, trending } = this.props;
    // console.log('bannerData: ', bannerData);

    return (
      <div className="Home w-100">
        <AdBanner height="250px" width="970px" margin="1rem 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {bannerData ? (
          <Banner bannerData={bannerData} clicked={this.navigate} />
        ) : (
          <BannerLoader />
        )}

        <OuterBox className="flex-column items-center">
          <InnerBox>
            <Latest
              title="Latest Updates"
              titleProps={{
                fontFamily: 'Montserrat',
                fontSize: '2.25rem',
                fontWeight: 'bold'
              }}
              contentData={latest}
              handleLoadMore={this.handleLoadMore}
              clicked={this.navigate}
            />

            <SideBar>
              <AdBanner height="250px" width="300px" margin="0 0 14px 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              {
                // eslint-disable-next-line
                <List_S_Image
                  className="List_S_Image mb3"
                  title="Trending"
                  listItems={trending}
                />
              }
              <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              <AdBanner height="250px" width="300px" margin="0 0 18px 0">
                <Image
                  src={adLinkedin}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </SideBar>
          </InnerBox>
          <InnerBox>
            {reviews ? (
              // eslint-disable-next-line
              <ReviewsOnHomePage
                className="ReviewsOnHomePage"
                title="Reviews"
                maxwidth="1040px"
                fontsize="2.25rem"
                fontfamily="Montserrat"
                listItems={reviews}
              />
            ) : null}
          </InnerBox>
        </OuterBox>

        <AdBanner height="250px" width="970px" margin="0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <FlexContainer className="flex justify-center items-center w-100 ph3">
          <FlexContainer
            className="flex flex-wrap ph3"
            style={{ maxWidth: '1040px' }}
          >
            <FlexContainer className="flex-column justify-around w-100 w-50-m w-50-l">
              <Title
                // className="w-100-s w-75"
                fontFamily="Montserrat"
                padding="1rem 0 0 0"
                fontSize="2.5rem"
                fontWeight="bold"
                color="#212121"
                // style={{ maxWidth: '351px' }}
                // style={{ minWidth: '368px' }}
              >
                Stay updated with the latest tech news
              </Title>
              <FlexContainer className="items-center">
                <Title
                  fontFamily="Montserrat"
                  // padding="0.5rem 0 0 0"
                  fontSize="0.8rem"
                  color="#212121"
                  style={{ maxWidth: '228px' }}
                >
                  Download our Beebom app for Android Now
                </Title>
                <img
                  className="pl3 pointer grow-large"
                  src={appLink}
                  onClick={() =>
                    goToURL(
                      'https://play.google.com/store/apps/details?id=com.beebom.app.beebom&utm_source=app.beebom.com&utm_medium=website&utm_campaign=landing'
                    )
                  }
                  alt="link-to-android-app"
                  width="112px"
                  height="33px"
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className="justify-center w-100 w-50-m w-50-l">
              <img
                src={phoneWithApp}
                height="410px"
                width="368px"
                alt="phone-with-app"
              />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>

        {/* <FlexContainer
          className="w-100"
          style={{ height: '5px', background: '#4db2ec' }}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state.home: ', state.home);
  return {
    loading: state.home.loading,
    bannerData: state.home.bannerData,
    latest: state.home.latest,
    pageForLatest: state.home.pageForLatest,
    trending: state.home.trending,
    reviews: state.home.reviews
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchHomeBanner: () => dispatch(Creators.fetchHomeBanner()),
  onFetchLatest: page => dispatch(Creators.fetchLatest(page)),
  onFetchReviews: () => dispatch(Creators.fetchReviews()),
  onFetchTrending: () => dispatch(Creators.fetchTrending())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
